import script from "./BaseRadioBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseRadioBtn.vue?vue&type=script&setup=true&lang=js"

import "./BaseRadioBtn.vue?vue&type=style&index=0&id=5de04678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de04678"]])

export default __exports__